<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <v-tour
                name="gerarCteTour"
                :steps="steps"
                :callbacks="callbacksTour"
              ></v-tour>
              <h4 class="card-title step-inicio">Gerar DOC</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreateDoc()"
                      v-b-tooltip
                      title="Gerar Documento"
                      v-if="getPermissionFw('gerardoc.store')"
                      ><i class="ft-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onCreateCteManual()"
                      v-b-tooltip
                      title="Gerar CTE Manual"
                      v-if="getPermissionFw('gerardoc.ctemanual.store')"
                      ><i class="ft-plus step-gerar"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="startTour()"
                      v-b-tooltip.hover.left="'Exibe tour inicial'"
                      ><i class="ft-monitor"></i
                    ></a>
                  </li>
                  <li>
                    <a @click="onShowHelp()" v-b-tooltip.hover.left="'Ajuda'"
                      ><i class="ft-help-circle"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onOcultar(2, null, false)"
                      v-b-tooltip
                      title="Mostrar Documentos"
                      v-if="getPermissionFw('gerardoc.ocultar')"
                      ><i class="ft-eye step-ocultar"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onOcultar(1, null, false)"
                      v-b-tooltip
                      title="Ocultar Documentos"
                      v-if="getPermissionFw('gerardoc.ocultar')"
                      ><i class="ft-eye-off"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                    <a
                      @click="ajusteNotasRecebedor()"
                      v-b-tooltip.hover.left="'Ajuste recebedor'"
                      ><i class="fa fa-file"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 70vh;">
                <div v-if="vuetableFilterRow" class="step-filtrar">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('gerardoc.store')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/gerardoc"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="docfis_id"
                    pagination-path=""
                    :load-on-start="false"
                    :no-data-template="tableNoData"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:loaded="onLoaded"
                    detail-row-component="cte-veiculo-detalhes"
                  >
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                        <a
                          v-if="props.rowData.ocultar == 2 && getPermissionFw('gerardoc.ocultar')"
                          @click="onOcultar(1, props.rowData, true)"
                          v-b-tooltip
                          title="Ocultar"
                          ><i class="fa fa-eye-slash"></i
                        ></a>
                        <a
                          v-if="props.rowData.ocultar == 1 && getPermissionFw('gerardoc.ocultar')"
                          @click="onOcultar(2, props.rowData, true)"
                          v-b-tooltip
                          title="Mostrar"
                          ><i class="fa fa-eye"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div class="col-md-12">
                  <div class="pull-left pagination-detail">
                    <vuetable-pagination-info
                      ref="paginationInfo"
                      :css="css.pagination"
                      info-class="pull-left"
                    ></vuetable-pagination-info>
                  </div>
                  <div class="pull-right m-a-0">
                    <vuetable-pagination
                      ref="pagination"
                      :css="css.pagination"
                      @vuetable-pagination:change-page="onChangePage"
                    ></vuetable-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Component -->
      <b-modal
        id="modal_help"
        ref="modal_help"
        :title="modal_titulo"
        close-title="Fechar"
        v-model="showModalHelp"
        size="lg"
      >
        <b-container fluid class="p-a-0">
          Você não precisa selecionar um documento na listagem, pode clicar
          diretamente no botão + e criar um CTE baseado nas características
          próprias <br />
          Lembre-se de levar em conta as seguintes características:<br />
          1) CTE Normal precisa de documento de carga ( Seja NFe, NF,
          Declaração, outros ) <br />
          2) Redespacho necessita dois dois documentos ( de carga e anterior )
          <br />
          3) Redespacho intermediário necessita apenas de documento anterior de
          transporte<br />
          4) Vinculado a multimodal não necessita de documentos vinculados.<br /><br />
          Caso prefira, você pode selecionar as notas fiscais na listagem e
          gerar o CTE, se atendando aos seguintes fatores:<br />
          1) Caso tenha mais de um destinatário ou remente colocar o CTE como
          Globalizado ( Verificar se o seu Estado já permite essa operação )<br />
          2) O tomador do serviço do CTE será o mesmo para todos os CTE's
          globalizados. E no DACTE o destinatario ou remetente ficará como
          "Diversos"<br />
        </b-container>
      </b-modal>

      <!-- Modal Component -->
      <b-modal
        id="modal_upload_xml"
        ref="modal_upload_xml"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        v-model="showModalXml"
      >
        <div class="col-md-12 col-sm-12">
          <label>Importar XML de NFe </label>
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :include-styling="true"
            v-on:vdropzone-success="showSuccess"
            v-on:vdropzone-error="showError"
            v-on:vdropzone-sending="sendingEvent"
            :options="dzOptions"
          >
          </vue-dropzone>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="float-right">
            <b-btn @click="showModalXml = false" variant="secondary">
              Fechar
            </b-btn>
          </div>
        </div>
      </b-modal>

      <!-- Modal Component -->
      <b-modal
        id="modal_upload_xml_cte"
        ref="modal_upload_xml_cte"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        v-model="showModalXmlCTe"
      >
        <div class="col-md-12 col-sm-12">
          <label>Importar XML de CTe </label>
          <vue-dropzone
            ref="myVueDropzoneCTe"
            id="dropzoneCTe"
            :include-styling="true"
            v-on:vdropzone-success="showSuccess"
            v-on:vdropzone-error="showErrorCTe"
            v-on:vdropzone-sending="sendingEvent"
            :options="dzOptionsCTe"
          >
          </vue-dropzone>
        </div>
        <div slot="modal-footer" class="w-100">
          <div class="float-right">
            <b-btn @click="showModalXmlCTe = false" variant="secondary">
              Fechar
            </b-btn>
          </div>
        </div>
      </b-modal>
      <GerarCteModalForm ref="gerarctemanualmodalform"> </GerarCteModalForm>
      <GerarDocModalForm ref="gerardocmodalform"> </GerarDocModalForm>
    </div>
  </div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GerarCteFilterBar from "./GerarCteFilterBar";
import CteVeiculoDetalhes from "./CteVeiculoDetalhes";
import vueDropzone from "vue2-dropzone";
import GerarCteModalForm from "./GerarCteModalForm";
import GerarDocModalForm from "./GerarDocModalForm";
import moment from "moment";
import Cookies from "js-cookie";

Vue.component("cte-veiculo-detalhes", CteVeiculoDetalhes);

export default {
  name: "gerarCteTour",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": GerarCteFilterBar,
    vueDropzone,
    GerarCteModalForm,
    GerarDocModalForm,
  },
  data() {
    return {
      callbacksTour: {
        onNextStep: this.tourNextStepCallback,
        onStop: this.tourStop,
      },
      steps: [
        {
          target: ".step-inicio", // We're using document.querySelector() under the hood
          content: `Para gerar um CTE é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`,
        },
        {
          target: ".step-xml-nfe", // We're using document.querySelector() under the hood
          content: `Nesta opção você pode importar o XML da NFe que seu cliente lhe enviou. Ao importar a NFe ela será apresentada na listagem abaixo`,
          params: {
            placement: "top",
          },
        },
        {
          target: ".step-xml-cte", // We're using document.querySelector() under the hood
          content: `Você pode importar xml de CTE também, para gerar seu CTE de redespacho ou redespacho intermediário com mais facilidade`,
          params: {
            placement: "top",
          },
        },
        {
          target: ".step-gerar",
          content:
            "Para gerar um CTE, você deve clicar no + ao lado! Para facilitar, você pode selecionar os documentos na listagem abaixo ( NFe importadas ) que irão estar presentes no CTE e clicar no mais, ou, pode clicar diretamente no botão e adicionar os documentos na tela que irá abrir",
          params: {
            placement: "left",
          },
        },
        {
          target: ".step-ocultar",
          content:
            "Você pode ocultar um documento da listagem, de forma a não visualizar. Basta selecionar o checkbox no lado esquerdo, e, ocultar em lote. Caso seja necessário reapresentar a NF, você pode filtrar os documentos ocultados.",
          params: {
            placement: "top",
          },
        },
        {
          target: ".step-filtrar",
          content:
            "Para filtrar um documento específico, localizar documentos já utilizados, você encontra diversos filtros de documentos importados",
          params: {
            placement: "top",
          },
        },
      ],
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: false,
      showModalSelect: false,
      showModalSel: false,
      showModalXml: false,
      showModalHelp: false,
      filter_data_store: {},
      showPopoverChaveNFe: false,
      showPopoverChaveCTe: false,
      optionsLivTpProcesso: [],
      optionsLivTpOperacao: [],
      optionsLivExigeConferenciaExp: [],
      showModalXmlCTe: false,
      filtros_form: new Form({
        canceladas: "",
        nfs_canceladas: "",
        chave: "",
        dt_fim: "",
        dt_inicio: "",
        emi_cnpj: "",
        fornecedor: "",
        num_fiscal: "",
        num_fiscal_doc: "",
        ocultar: "",
        utilizadas: "",
        usuario_inc: "",
        dt_inc_inicio: "",
        dt_inc_fim: "",
        dt_pre_inicio: "",
        dt_pre_fim: "",
        nfe_reversa: "",
      }),
      help_form: new Form({
        ocultarRecord: [],
        globalizado: 2,
      }),
      dzOptions: {
        url: (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : process.env.VUE_APP_HTTP+(this.apiVersion === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + "/api/xmlnfe",
        withCredentials: true,
        maxFiles: 10,
        maxFilesize: 1,
        addRemoveLinks: false,
        thumbnailWidth: 140,
        thumbnailHeight: 10,
        uploadMultiple: false,
        acceptedFiles: ".xml",
        dictDefaultMessage:
          "Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos",
        dictFallbackMessage:
          "O seu browser não suporta arrastar para cá. Clique aqui.",
        dictFallbackText: "Use o formulário alternativo abaixo para envio.",
        dictFileTooBig:
          "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
        dictInvalidFileType: "Tipo do arquivo inválido para upload.",
        dictResponseError:
          "Server respondeu com código de erro {{statusCode}} code.",
        dictCancelUpload: "Cancelar envio",
        dictCancelUploadConfirmation:
          "Tem certeza que deseja cancelar o envio ?",
        dictRemoveFile: "Remover arquivo",
        dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
        headers: {
          "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
          "Cache-Control": null,
        },
      },
      dzOptionsCTe: {
        url: (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : process.env.VUE_APP_HTTP+(this.apiVersion === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + "/api/xmlcte",
        withCredentials: true,
        maxFiles: 10,
        maxFilesize: 1,
        addRemoveLinks: false,
        thumbnailWidth: 140,
        thumbnailHeight: 10,
        uploadMultiple: false,
        acceptedFiles: ".xml",
        dictDefaultMessage:
          "Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos",
        dictFallbackMessage:
          "O seu browser não suporta arrastar para cá. Clique aqui.",
        dictFallbackText: "Use o formulário alternativo abaixo para envio.",
        dictFileTooBig:
          "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
        dictInvalidFileType: "Tipo do arquivo inválido para upload.",
        dictResponseError:
          "Server respondeu com código de erro {{statusCode}} code.",
        dictCancelUpload: "Cancelar envio",
        dictCancelUploadConfirmation:
          "Tem certeza que deseja cancelar o envio ?",
        dictRemoveFile: "Remover arquivo",
        dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
        headers: {
          "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
          "Cache-Control": null,
        },
      },
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "Nº Fiscal",
        },
        {
          name: "serie",
          title: "Serie",
        },
        {
          name: "dt_emissao",
          title: "Data Emissão",
          callback: "formatDate|DD/MM/YYYY",
        },
        {
          name: "doc_fiscal_partes_env.emi_cnpj",
          title: "CNPJ",
        },
        {
          name: "doc_fiscal_partes_env.emi_nome",
          title: "Razão Social",
        },
        {
          name: "dt_inc",
          title: "Data de Inclusão",
          callback: this.formatDateSubmit,
        },
        {
          name: "dt_previsao",
          title: "Data de Previsão",
          callback: this.formatDateSubmit,
        },
        {
          name: "carga_doc.doc_carga_doc.doc.num_fiscal",
          title: "CTE",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
      tableNoData: "Adicione um filtro para carregar a tela",
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onCreateCteManual() {
      this.$refs.gerarctemanualmodalform.onCreate();
    },
    onCreateDoc(data_filter, tipo) {
    if(tipo == 2){
        this.filter_data_store = data_filter;
    }
    if(tipo != 2){
      this.$refs.gerardocmodalform.onCreate(this.filter_data_store);
    }
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if(tipo == 2){
        this.filter_data_store = data_filter;
      }
      if(tipo != 2){
        this.loadingData = true;
        console.log('this.filter_data_store');
        console.log(this.filter_data_store);
        if(this.$refs.vuetable.selectedTo.length == 0){
          this.filtros_form.canceladas = this.filter_data_store.canceladas;
          this.filtros_form.nfs_canceladas = this.filter_data_store.nfs_canceladas;
          this.filtros_form.chave = this.filter_data_store.chave;
          this.filtros_form.dt_fim = this.filter_data_store.dt_fim;
          this.filtros_form.dt_inicio = this.filter_data_store.dt_inicio;
          this.filtros_form.dt_inc_inicio = this.filter_data_store.dt_inc_inicio;
          this.filtros_form.dt_inc_fim = this.filter_data_store.dt_inc_fim;
          this.filtros_form.dt_pre_inicio = this.filter_data_store.dt_pre_inicio;
          this.filtros_form.dt_pre_fim = this.filter_data_store.dt_pre_fim;
          this.filtros_form.emi_cnpj = this.filter_data_store.emi_cnpj;
          this.filtros_form.fornecedor = this.filter_data_store.fornecedor;
          this.filtros_form.num_fiscal = this.filter_data_store.num_fiscal;
          this.filtros_form.num_fiscal_doc = this.filter_data_store.num_fiscal_doc;
          this.filtros_form.ocultar = this.filter_data_store.ocultar;
          this.filtros_form.utilizadas = this.filter_data_store.utilizadas;
          this.filtros_form.usuario_inc = this.filter_data_store.usuario_inc;
          this.filtros_form.nfe_reversa = this.filter_data_store.nfe_reversa;
          this.filtros_form
          .post("/api/gerardoc/all")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            response.forEach((obj)=>{
              this.$refs.vuetable.selectedTo.push(parseFloat(obj));
            })
            this.loadingData = false
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
            this.loadingData = false
          });
        }else{
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    startTour() {
      this.$tours["gerarCteTour"].start();
    },
    tourNextStepCallback(currentStep) {
      // if(currentStep) Abrir o menu com opções
    },
    tourStop() {},
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {

      this.loadingData = true;
      this.tableNoData = "Nenhum resultado encontrado";
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        num_fiscal_doc: data_filter.num_fiscal_doc,
        emi_cnpj: data_filter.emi_cnpj,
        chave: data_filter.chave,
        usuario_inc: data_filter.usuario_inc,
        ocultar: data_filter.ocultar,
        utilizadas: data_filter.utilizadas,
        canceladas: data_filter.canceladas,
        nfs_canceladas: data_filter.nfs_canceladas,
        dt_inc_inicio: data_filter.dt_inc_inicio,
        dt_inc_fim: data_filter.dt_inc_fim,
        dt_pre_inicio: data_filter.dt_pre_inicio,
        dt_pre_fim: data_filter.dt_pre_fim,
        dt_inicio: data_filter.dt_inicio,
        dt_fim: data_filter.dt_fim,
        nfe_reversa: data_filter.nfe_reversa,
        fornecedor: data_filter.fornecedor.pessoa_id,
        redespacho: data_filter.redespacho,
      };
      if(JSON.stringify(this.moreParams) != '{}'){
        this.searchAll(this.moreParams, 2);
        this.onCreateDoc(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = false;
      this.$refs.vuetable.selectedTo = null;
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      this.moreParams = {};
      this.tableNoData = "Adicione um filtro para carregar a tela";
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      if (
        (!this.$refs.vuetable.tableData || this.$refs.vuetable.tableData.length === 0) &&
        Object.keys(this.moreParams).length > 0
      ) {
        this.tableNoData = "Nenhum resultado encontrado";
      }
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      }
    },
    onImportXml(data) {
      this.modal_titulo = "Importar XML de NFe";
      this.modal_botao = "Importar";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.$refs.modal_upload_xml.show();
    },
    onImportXmlCte(data) {
      this.modal_titulo = "Importar XML de CTe";
      this.modal_botao = "Importar";
      this.modal_acao = "i";
      this.loading = false;
      this.isDisabled = false;
      this.$refs.modal_upload_xml_cte.show();
    },
    onShowHelp() {
      this.modal_titulo = "Ajuda";
      this.modal_acao = "i";
      this.showModalHelp = true;
    },
    showSuccess: function (file, message, xhr) {
      this.$snotify.success(message + " para arquivo " + file.name);
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    showError: function (file, message, xhr) {
      this.$snotify.error(message + " para arquivo " + file.name);
    },
    showErrorCTe: function (file, message, xhr) {
      this.$snotify.error(message.message + " para arquivo " + file.name);
    },
    sendingEvent(file, xhr, formData) {
      formData.append("paramName", "some value or other");
    },
    formatTypedDate: function (dateString) {
      let result = dateString.split("/");
      return result[2] + "-" + result[1] + "-" + result[0] + "T00:00:00-03:00";
    },
    ajusteNotasRecebedor() {
      this.help_form
        .post("/api/gerardoc/ajustenotarecebedor")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onOcultar(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.help_form.ocultarRecord = [];
        this.help_form.ocultarRecord.push({
          id: data.docfis_id,
          status: action,
        });
      } else {
        this.help_form.ocultarRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.help_form.ocultarRecord.push({ id: obj, status: action });
        });
      }

      this.loading = true;
      this.isDisabled = true;
      this.help_form
        .post("/api/gerardoc/ocultar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.help_form
        .get("/api/gerardoc/jsonlistdoc")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.tp_processo.forEach((obj) => {
            this.optionsLivTpProcesso.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_operacao.forEach((obj) => {
            this.optionsLivTpOperacao.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.exige_conferencia_exp.forEach((obj) => {
            this.optionsLivExigeConferenciaExp.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    apiVersion: {
      get() {
        return this.$store.getters.api_version;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
